export default __webpack_public_path__ + "static/media/result_3.e0f251a8.jpg";